module.exports = __webpack_public_path__ + "img/arrowDown.b56edbc8.svg";